import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { FaThLarge } from "react-icons/fa";
const config = {
    BASE_URL: "https://admin.thezeeshangroup.com/",
};
const Featuredproperties = () => {
    const [getFeaturedPropertiesData, setGetFeaturedPropertiesData] = useState([]);
    const [loader, setLoader] = useState(true);
    const featuredpropertiesApi = async () => {
        try {
            const res = await apiClient.get(`api/featured-properties`);
            setLoader(true);
            setGetFeaturedPropertiesData(res.data);
            setLoader(false);
        } catch (error) {
            console.log(error.message);
        }
    };
    useEffect(() => {
        featuredpropertiesApi();
    }, []);
    return (
        <>

            {loader ? (
                <div className="d-flex justify-content-center">
                    <LineWave
                        height="250"
                        width="150"
                        color="#56b13d"
                        ariaLabel="line-wave"
                    />
                </div>
            ) : (
                getFeaturedPropertiesData.map((item, i) => {
                    return (
                        <>
                            <Col lg="4" md="6" className="mb-4">
                                <Link
                                    to={"/property/" + item.id}
                                    style={{ color: "black" }}
                                >
                                    <div className="featured">
                                        <div className="top">
                                            <img src={`${config.BASE_URL}uploads/featuredproperties/${item.image}`} alt={item.name} />
                                        </div>
                                        <div className="bottom">
                                            <h3>{item.name}</h3>
                                            <p>{item.address}</p>
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <span>Bedrooms</span>
                                                    <div className="d-flex align-items-center icon">
                                                        <FaThLarge />
                                                        <span>{item.bedroom}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="price">
                                                <p>For Sale</p>
                                                {item.price !== "0" ? (
                                                    <span>
                                                        &#8377;{item.price} <small>Onwards</small>
                                                    </span>
                                                ) : (
                                                    <span>Booking will start soon</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                        </>
                    );
                })
            )}
        </>
    );
};

export default Featuredproperties;
